import { useEffect, useState } from "react";
import { subscribeAnalytics, type AnalyticsEvent } from "@/lib/analytics";

/**
 * Dev-only floating panel showing the last FAQ analytics events with
 * their payloads. Rendered only when import.meta.env.DEV is true.
 */
const FaqDebugPanel = () => {
  const [events, setEvents] = useState<AnalyticsEvent[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const off = subscribeAnalytics((e) => {
      if (!e.name.startsWith("faq_")) return;
      setEvents((prev) => [e, ...prev].slice(0, 25));
    });
    return off;
  }, []);

  if (!import.meta.env.DEV) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 12,
        right: 12,
        zIndex: 99999,
        fontFamily: "ui-monospace,Menlo,monospace",
        fontSize: 11,
        maxWidth: 380,
      }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          background: "#111",
          color: "#FFC600",
          border: "1px solid #333",
          padding: "4px 10px",
          cursor: "pointer",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}
      >
        FAQ debug · {events.length}
      </button>
      {open && (
        <div
          style={{
            marginTop: 6,
            background: "rgba(10,10,10,0.95)",
            color: "#eee",
            border: "1px solid #333",
            padding: 8,
            maxHeight: 320,
            overflow: "auto",
          }}
        >
          {events.length === 0 ? (
            <div style={{ opacity: 0.6 }}>No FAQ events yet.</div>
          ) : (
            events.map((e, i) => (
              <div
                key={i}
                style={{ borderBottom: "1px solid #222", padding: "4px 0" }}
              >
                <div style={{ color: "#FFC600" }}>{e.name}</div>
                <pre style={{ margin: 0, whiteSpace: "pre-wrap", color: "#bbb" }}>
                  {JSON.stringify(e.params, null, 0)}
                </pre>
              </div>
            ))
          )}
          <button
            onClick={() => setEvents([])}
            style={{
              marginTop: 6,
              background: "transparent",
              color: "#888",
              border: "1px solid #333",
              padding: "2px 8px",
              cursor: "pointer",
            }}
          >
            clear
          </button>
        </div>
      )}
    </div>
  );
};

export default FaqDebugPanel;